import { lazy } from 'react'

import { Constants } from '@adobe/aem-spa-page-model-manager'
import withAdobeTarget from '@cox/core-ui8/dist/withAdobeTarget'

import { COMPONENTS_PATH } from '../constants'
import { RuleType } from '../utils/types'

const Accordion = lazy(() => import('../components/ReactAccordion'))
const AddressCapture = lazy(() => import('../components/ReactAddressCapture'))
const Ankle = lazy(() => import('../components/ReactAnkle'))
const Badge = lazy(() => import('../components/ReactBadge'))
const Banner = lazy(() => import('../components/ReactBanner'))
const BBFL = lazy(() => import('../components/ReactBBFL'))
const Breadcrumb = lazy(() => import('../components/ReactBreadcrumb'))
const Button = lazy(() => import('../components/ReactButton'))
const Calculator = lazy(() => import('../components/ReactCalculator'))
const Carousel = lazy(() => import('../components/ReactCarousel'))
const ChannelLineup = lazy(() => import('../components/ReactChannelLineup'))
const ContentFragment = lazy(() => import('../components/ReactContentFragment'))
const Communities = lazy(() => import('../components/ReactCommunities'))
const CountdownClock = lazy(() => import('../components/ReactCountdownClock'))
const Footer = lazy(() => import('../components/ReactFooter'))
const FormContainer = lazy(() => import('../components/ReactFormContainer'))
const Header = lazy(() => import('../components/ReactHeader'))
const Hotspot = lazy(() => import('../components/ReactHotspot'))
const Html = lazy(() => import('../components/ReactHtml'))
const HTMLTag = lazy(() => import('../components/ReactHTMLTag'))
const Image = lazy(() => import('../components/ReactImage'))
const InternationalRates = lazy(() => import('../components/ReactInternationalRates'))
const Intercept = lazy(() => import('../components/ReactIntercept'))
const Layout = lazy(() => import('../components/ReactLayout'))
const List = lazy(() => import('../components/ReactList'))
const MapContainer = lazy(() => import('../components/ReactMapContainer'))
const Modal = lazy(() => import('../components/ReactModal'))
const OfferElements = lazy(() => import('../components/ReactOfferElements'))
const Oliver = lazy(() => import('../components/ReactOliver'))
const Price = lazy(() => import('../components/ReactPrice'))
const PricingGuides = lazy(() => import('../components/ReactPricingGuides'))
const PropertiesCodeBlock = lazy(() => import('../components/ReactPropertiesCodeBlock'))
const RelatedSearch = lazy(() => import('../components/ReactRelatedSearch'))
const RevealCards = lazy(() => import('../components/ReactRevealCards'))
/**WithAdobeTarget is not required for rulebuilder and rulebuilderconditional as component internally uses AdobeTargetContext*/
const ReactRuleBuilder = lazy(() => import('../components/ReactRuleBuilder/ReactRuleBuilder'))
const ReactRuleBuilderConditional = lazy(() => import('../components/ReactRuleBuilderConditional'))
const RuleSearch = lazy(() => import('../components/ReactRuleSearch'))
const StoreLocator = lazy(() => import('../components/ReactStoreLocator'))
const Search = lazy(() => import('../components/ReactSearch'))
const SearchField = lazy(() => import('../components/ReactSearchField'))
const SearchLinks = lazy(() => import('../components/ReactSearchLinks'))
const SearchResults = lazy(() => import('../components/ReactSearchResults'))
const SectionHeader = lazy(() => import('../components/ReactSectionHeader'))
const Separator = lazy(() => import('../components/ReactSeparator'))
const SolutionList = lazy(() => import('../components/ReactSolutionList'))
const Sticky = lazy(() => import('../components/ReactSticky'))
const Stores = lazy(() => import('../components/ReactStores'))
const Table = lazy(() => import('../components/ReactTable'))
const Tabs = lazy(() => import('../components/ReactTabs'))
const Teaser = lazy(() => import('../components/ReactTeaser'))
const Text = lazy(() => import('../components/ReactText'))
const Title = lazy(() => import('../components/ReactTitle'))
const UserAlerts = lazy(() => import('../components/ReactUserAlerts'))
const Video = lazy(() => import('../components/ReactVideo'))
const VideoList = lazy(() => import('../components/ReactVideoList'))
const SharedResponsiveContainer = lazy(() => import('../components/shared/ResponsiveContainer'))

const ReactAccordion = withAdobeTarget(Accordion, { compName: 'Accordion' })
const ReactAddressCapture = withAdobeTarget(AddressCapture, { compName: 'AddressCapture' })
const ReactAnkle = withAdobeTarget(Ankle, { compName: 'Ankle' })
const ReactBadge = withAdobeTarget(Badge, { compName: 'Badge' })
const ReactBanner = withAdobeTarget(Banner, { compName: 'Banner' })
const ReactBBFL = withAdobeTarget(BBFL, { compName: 'BBFL' })
const ReactBreadcrumb = withAdobeTarget(Breadcrumb, { compName: 'Breadcrumb' })
const ReactButton = withAdobeTarget(Button, { compName: 'Button' })
const ReactCalculator = withAdobeTarget(Calculator, { compName: 'Calculator' })
const ReactCarousel = withAdobeTarget(Carousel, { compName: 'Carousel' })
const ReactChannelLineup = withAdobeTarget(ChannelLineup, { compName: 'ChannelLineup' })
const ReactCommunities = withAdobeTarget(Communities)
const ReactContentFragment = withAdobeTarget(ContentFragment, { compName: 'ContentFragment' })
const ReactCoxStores = withAdobeTarget(Stores, { compName: 'CoxStores' })
const ReactCountdownClock = withAdobeTarget(CountdownClock, { compName: 'CountdownClock' })
const ReactFooter = withAdobeTarget(Footer, { compName: 'Footer' })
const ReactFormContainer = withAdobeTarget(FormContainer, { compName: 'FormContainer' })
const ReactHeader = withAdobeTarget(Header, { compName: 'Header' })
const ReactHotspot = withAdobeTarget(Hotspot, { compName: 'Hotspot' })
const ReactHtml = withAdobeTarget(Html, { compName: 'Html' })
const ReactHTMLTag = withAdobeTarget(HTMLTag, { compName: 'HTMLTag' })
const ReactImage = withAdobeTarget(Image, { compName: 'Image' })
const ReactInternationalRates = withAdobeTarget(InternationalRates, { compName: 'InternationalRates' })
const ReactIntercept = withAdobeTarget(Intercept, { compName: 'Intercept' })
const ReactLayout = withAdobeTarget(Layout, { compName: 'Layout' })
const ReactList = withAdobeTarget(List, { compName: 'List' })
const ReactMapContainer = withAdobeTarget(MapContainer, { compName: 'MapContainer' })
const ReactModal = withAdobeTarget(Modal, { compName: 'Modal' })
const ReactOfferElements = withAdobeTarget(OfferElements, { compName: 'OfferElements' })
const ReactOliver = withAdobeTarget(Oliver, { compName: 'Oliver' })
const ReactPrice = withAdobeTarget(Price, { compName: 'Price' })
const ReactPricingGuides = withAdobeTarget(PricingGuides)
const ReactPropertiesCodeBlock = withAdobeTarget(PropertiesCodeBlock, { compName: 'PropertiesCodeBlock' })
const ReactRelatedSearch = withAdobeTarget(RelatedSearch, { compName: 'RelatedSearch' })
const ReactRevealCards = withAdobeTarget(RevealCards, { compName: 'RevealCards' })
const ReactRuleSearch = withAdobeTarget(RuleSearch, { compName: 'RuleSearch' })
const ReactSearch = withAdobeTarget(Search, { compName: 'Search' })
const ReactSearchField = withAdobeTarget(SearchField, { compName: 'SearchField' })
const ReactSearchLinks = withAdobeTarget(SearchLinks, { compName: 'SearchLinks' })
const ReactSearchResults = withAdobeTarget(SearchResults, { compName: 'SearchResults' })
const ReactSectionHeader = withAdobeTarget(SectionHeader, { compName: 'SectionHeader' })
const ReactSeparator = withAdobeTarget(Separator, { compName: 'Separator' })
const ReactSolutionList = withAdobeTarget(SolutionList, { compName: 'SolutionList' })
const ReactSticky = withAdobeTarget(Sticky, { compName: 'Sticky' })
const ReactStoreLocator = withAdobeTarget(StoreLocator, { compName: 'ReactStoreLocator' })
const ReactTable = withAdobeTarget(Table, { compName: 'Table' })
const ReactTabs = withAdobeTarget(Tabs, { compName: 'Tabs' })
const ReactTeaser = withAdobeTarget(Teaser, { compName: 'Teaser' })
const ReactText = withAdobeTarget(Text, { compName: 'Text' })
const ReactTitle = withAdobeTarget(Title, { compName: 'Title' })
const ReactUserAlerts = withAdobeTarget(UserAlerts, { compName: 'UserAlerts' })
const ReactVideo = withAdobeTarget(Video, { compName: 'Video' })
const ReactVideoList = withAdobeTarget(VideoList, { compName: 'VideoList' })
const ResponsiveContainer = withAdobeTarget(SharedResponsiveContainer, { compName: 'SharedResponsiveContainer' })

const ComponentTypeRenderer = (props: {
  componentType: string
  componentProps: any
  condition?: string
  ruleType?: RuleType
  ruleExpression?: string
  ruleId?: string
  index?: number
}) => {
  const { componentType, componentProps, condition, ruleType, ruleExpression = '', index, ruleId = '' } = props
  const items = componentProps?.[Constants.ITEMS_PROP]
  const itemsOrder = componentProps?.[Constants.ITEMS_ORDER_PROP]
  if (componentType === `${COMPONENTS_PATH}/reactteaser`) {
    return <ReactTeaser {...componentProps} ruleExpression={ruleExpression} condition={condition} ruleType={ruleType} />
  } else if (componentType === `${COMPONENTS_PATH}/experiencefragment`) {
    return (
      <ResponsiveContainer
        ruleExpression={ruleExpression}
        condition={condition}
        ruleType={ruleType}
        componentProps={componentProps[Constants.ITEMS_PROP]?.root}
      />
    )
  } else if (componentType === `${COMPONENTS_PATH}/carousel`) {
    return (
      <ReactCarousel
        autoplay={false}
        autopauseDisabled={false}
        accessibilityLabel={''}
        accessibility={{
          play: 'Play',
          pause: 'Pause',
          next: 'Next',
          previous: 'Previous',
          slide: 'Slide {0} of {1}',
          indicator: 'Slide %{0}',
          indicators: 'Choose a slide to display'
        }}
        delay={0}
        cqItems={{}}
        allowedComponents={{ applicable: false, components: [] }}
        cqItemsOrder={[]}
        cqPath={''}
        {...componentProps}
        ruleExpression={ruleExpression}
        condition={condition}
        ruleType={ruleType}
      />
    )
  } else if (componentType === `${COMPONENTS_PATH}/reactbanner`) {
    return <ReactBanner {...componentProps} />
  } else if (componentType === `${COMPONENTS_PATH}/image`) {
    return <ReactImage {...componentProps} />
  } else if (componentType === `${COMPONENTS_PATH}/list`) {
    return <ReactList {...componentProps} />
  } else if (componentType === `${COMPONENTS_PATH}/title`) {
    return <ReactTitle {...componentProps} />
  } else if (componentType === `${COMPONENTS_PATH}/text`) {
    return <ReactText {...componentProps} index={index} />
  } else if (componentType === `${COMPONENTS_PATH}/button`) {
    return <ReactButton {...componentProps} />
  } else if (
    componentType === `${COMPONENTS_PATH}/container` ||
    componentType === `wcm/foundation/components/responsivegrid`
  ) {
    return (
      <ResponsiveContainer
        componentProps={componentProps}
        ruleExpression={ruleExpression}
        condition={condition}
        ruleType={ruleType}
      />
    )
  } else if (componentType === `${COMPONENTS_PATH}/accordion`) {
    return <ReactAccordion {...componentProps} cqItems={items} cqItemsOrder={itemsOrder} />
  } else if (componentType === `${COMPONENTS_PATH}/ankle`) {
    return <ReactAnkle {...componentProps} cqItems={items} cqItemsOrder={itemsOrder} />
  } else if (componentType === `${COMPONENTS_PATH}/reactbreadcrumb`) {
    return <ReactBreadcrumb {...componentProps} cqItems={items} cqItemsOrder={itemsOrder} />
  } else if (componentType === `${COMPONENTS_PATH}/addresscapture`) {
    return <ReactAddressCapture {...componentProps} cqItems={items} cqItemsOrder={itemsOrder} />
  } else if (componentType === `${COMPONENTS_PATH}/modal`) {
    return <ReactModal {...componentProps} cqItems={items} cqItemsOrder={itemsOrder} {...props} />
  } else if (componentType === `${COMPONENTS_PATH}/reactcontentfragment`) {
    return <ReactContentFragment {...componentProps} cqItems={items} cqItemsOrder={itemsOrder} />
  } else if (componentType === `${COMPONENTS_PATH}/footer`) {
    return <ReactFooter {...componentProps} cqItems={items} cqItemsOrder={itemsOrder} />
  } else if (componentType === `${COMPONENTS_PATH}/form/container`) {
    return <ReactFormContainer {...componentProps} cqItems={items} cqItemsOrder={itemsOrder} />
  } else if (componentType === `${COMPONENTS_PATH}/header`) {
    return <ReactHeader {...componentProps} cqItems={items} cqItemsOrder={itemsOrder} />
  } else if (componentType === `${COMPONENTS_PATH}/htmltag`) {
    return <ReactHTMLTag {...componentProps} cqItems={items} cqItemsOrder={itemsOrder} />
  } else if (componentType === `${COMPONENTS_PATH}/htmlembed`) {
    return <ReactHtml {...componentProps} cqItems={items} cqItemsOrder={itemsOrder} />
  } else if (componentType === `${COMPONENTS_PATH}/mapcontainer`) {
    return <ReactMapContainer {...componentProps} cqItems={items} cqItemsOrder={itemsOrder} />
  } else if (componentType === `${COMPONENTS_PATH}/oliver`) {
    return <ReactOliver {...componentProps} cqItems={items} cqItemsOrder={itemsOrder} />
  } else if (componentType === `${COMPONENTS_PATH}/reactprice`) {
    return (
      <ReactPrice
        {...componentProps}
        cqItems={items}
        cqItemsOrder={itemsOrder}
        ruleExpression={ruleExpression}
        index={index}
      />
    )
  } else if (componentType === `${COMPONENTS_PATH}/pricingguides`) {
    return <ReactPricingGuides {...componentProps} cqItems={items} cqItemsOrder={itemsOrder} />
  } else if (componentType === `${COMPONENTS_PATH}/reactofferelements`) {
    return <ReactOfferElements {...componentProps} cqItems={items} cqItemsOrder={itemsOrder} index={index} {...props} />
  } else if (componentType === `${COMPONENTS_PATH}/propertiescodeblock`) {
    return <ReactPropertiesCodeBlock {...componentProps} cqItems={items} cqItemsOrder={itemsOrder} />
  } else if (componentType === `${COMPONENTS_PATH}/relatedsearch`) {
    return <ReactRelatedSearch {...componentProps} cqItems={items} cqItemsOrder={itemsOrder} />
  } else if (componentType === `${COMPONENTS_PATH}/revealcards`) {
    return <ReactRevealCards {...componentProps} cqItems={items} cqItemsOrder={itemsOrder} />
  } else if (componentType === `${COMPONENTS_PATH}/rulesearch`) {
    return <ReactRuleSearch {...componentProps} cqItems={items} cqItemsOrder={itemsOrder} />
  } else if (componentType === `${COMPONENTS_PATH}/search`) {
    return <ReactSearch {...componentProps} cqItems={items} cqItemsOrder={itemsOrder} />
  } else if (componentType === `${COMPONENTS_PATH}/searchfield`) {
    return <ReactSearchField {...componentProps} cqItems={items} cqItemsOrder={itemsOrder} />
  } else if (componentType === `${COMPONENTS_PATH}/searchlinks`) {
    return <ReactSearchLinks {...componentProps} cqItems={items} cqItemsOrder={itemsOrder} />
  } else if (componentType === `${COMPONENTS_PATH}/searchresults`) {
    return <ReactSearchResults {...componentProps} cqItems={items} cqItemsOrder={itemsOrder} />
  } else if (componentType === `${COMPONENTS_PATH}/reactsectionheader`) {
    return <ReactSectionHeader {...componentProps} cqItems={items} cqItemsOrder={itemsOrder} />
  } else if (componentType === `${COMPONENTS_PATH}/separator`) {
    return <ReactSeparator {...componentProps} cqItems={items} cqItemsOrder={itemsOrder} />
  } else if (componentType === `${COMPONENTS_PATH}/solutionlist`) {
    return <ReactSolutionList {...componentProps} cqItems={items} cqItemsOrder={itemsOrder} />
  } else if (componentType === `${COMPONENTS_PATH}/sticky`) {
    return <ReactSticky {...componentProps} cqItems={items} cqItemsOrder={itemsOrder} />
  } else if (componentType === `${COMPONENTS_PATH}/storecoreinfo`) {
    return <ReactCoxStores {...componentProps} cqItems={items} cqItemsOrder={itemsOrder} />
  } else if (componentType === `${COMPONENTS_PATH}/storelocator`) {
    return <ReactStoreLocator {...componentProps} cqItems={items} cqItemsOrder={itemsOrder} />
  } else if (componentType === `${COMPONENTS_PATH}/tabs`) {
    return <ReactTabs {...componentProps} cqItems={items} cqItemsOrder={itemsOrder} />
  } else if (componentType === `${COMPONENTS_PATH}/reactbadge`) {
    return <ReactBadge {...componentProps} cqItems={items} cqItemsOrder={itemsOrder} />
  } else if (componentType === `${COMPONENTS_PATH}/rulebuilder`) {
    return <ReactRuleBuilder {...componentProps} cqItems={items} cqItemsOrder={itemsOrder} ruleId={ruleId} />
  } else if (componentType === `${COMPONENTS_PATH}/rulebuilderconditional`) {
    return <ReactRuleBuilderConditional {...componentProps} cqItems={items} cqItemsOrder={itemsOrder} ruleId={ruleId} />
  } else if (componentType === `${COMPONENTS_PATH}/react-rte-table/reacttable`) {
    return <ReactTable {...componentProps} cqItems={items} cqItemsOrder={itemsOrder} />
  } else if (componentType === `${COMPONENTS_PATH}/reactlayout`) {
    return <ReactLayout cqItems={items} cqItemsOrder={itemsOrder} {...componentProps} />
  } else if (componentType === `${COMPONENTS_PATH}/reactcalculator`) {
    return <ReactCalculator {...componentProps} cqItems={items} cqItemsOrder={itemsOrder} />
  } else if (componentType === `${COMPONENTS_PATH}/reactbbfl`) {
    return <ReactBBFL {...componentProps} ruleExpression={ruleExpression} />
  } else if (componentType === `${COMPONENTS_PATH}/reactcountdownclock`) {
    return <ReactCountdownClock {...componentProps} cqItems={items} cqItemsOrder={itemsOrder} />
  } else if (componentType === `${COMPONENTS_PATH}/reactchannellineup`) {
    return <ReactChannelLineup {...componentProps} cqItems={items} cqItemsOrder={itemsOrder} />
  } else if (componentType === `${COMPONENTS_PATH}/useralerts`) {
    return <ReactUserAlerts {...componentProps} cqItems={items} cqItemsOrder={itemsOrder} />
  } else if (componentType === `${COMPONENTS_PATH}/intercept`) {
    return <ReactIntercept {...componentProps} cqItems={items} cqItemsOrder={itemsOrder} />
  } else if (componentType === `${COMPONENTS_PATH}/internationalrates`) {
    return <ReactInternationalRates {...componentProps} cqItems={items} cqItemsOrder={itemsOrder} />
  } else if (componentType === `${COMPONENTS_PATH}/reactcommunities`) {
    return <ReactCommunities {...componentProps} cqItems={items} cqItemsOrder={itemsOrder} />
  } else if (componentType === `${COMPONENTS_PATH}/embed`) {
    return <ReactVideo {...componentProps} cqItems={items} cqItemsOrder={itemsOrder} />
  } else if (componentType === `${COMPONENTS_PATH}/videolist`) {
    return <ReactVideoList {...componentProps} cqItems={items} cqItemsOrder={itemsOrder} />
  } else if (componentType === `${COMPONENTS_PATH}/hotspot`) {
    return <ReactHotspot {...componentProps} cqItems={items} cqItemsOrder={itemsOrder} />
  }

  return <></>
}

export default ComponentTypeRenderer
